<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminPositionRemarquableForm from '@/components/admin/positionRemarquable/AdminPositionRemarquableForm.vue'
import { AloPositionRemarquable } from '@/models/alo/AloPositionRemarquable'
import { SecurityItemsKeys } from '@/enum/SecurityItems'

@Component({
  name: 'AdminPositionRemarquable', 
  components: {AdminPositionRemarquableForm},
  props:{
    itemid:{
      type:Number
    }
  }
})
export default class AdminPositionRemarquable extends AdminForm<AloPositionRemarquable> {  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_POSITIONREMARQUABLE].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }

  get itemTypeName(){
    return "PositionRemarquable"
  }

  get originalLibelle(){
    return this.original.prmLibelle
  }
}
</script>